"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Usd = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Usd = function Usd(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#USD_svg__USD_svg__clip0_9086_35)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#ECEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.405 12.75v-.723c1.651-.13 2.597-.979 2.597-2.34 0-1.154-.678-1.854-2.056-2.182l-.541-.115V5.12c.667.088 1.132.547 1.148 1.127h1.307c-.027-1.23-.979-2.111-2.455-2.242V3.25H7.65v.755c-1.548.136-2.477.979-2.477 2.27 0 1.093.689 1.837 1.952 2.143l.525.131v2.39c-.771-.087-1.269-.53-1.318-1.154H4.998c.005 1.29 1.022 2.15 2.652 2.253v.711h.755zm1.268-2.921c0 .656-.464 1.072-1.268 1.121V8.691c.87.175 1.268.536 1.268 1.138zM6.518 6.165c0-.58.476-1.012 1.132-1.05V7.23c-.738-.153-1.132-.52-1.132-1.066z",
    fill: "#505F79"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "USD_svg__USD_svg__clip0_9086_35"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};

exports.Usd = Usd;
var _default = Usd;
exports.default = _default;